import { View } from "react-native";
import { StyleSheet } from "react-native-unistyles";
import "../../../theme";
import { Text } from "../../Text";
import type { SearchResult, SearchResultGroup } from "../types";

function SearchGroupHeader<T extends SearchResult>({ group }: { readonly group: SearchResultGroup<T> }) {
  return (
    <View style={styles.groupHeader}>
      <Text textStyle="xs/semibold" color="textMuted" style={styles.groupHeaderText}>
        {group.name.toUpperCase()}
      </Text>
    </View>
  );
}

SearchGroupHeader.displayName = "SearchGroupHeader";

export { SearchGroupHeader };

const styles = StyleSheet.create((theme) => ({
  groupHeader: {
    paddingHorizontal: theme.spacing["3xl"],
    paddingVertical: theme.spacing.md,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.border,
  },
  groupHeaderText: {
    letterSpacing: 1,
  },
}));
